import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetsModule } from 'src/widgets/widgets.module';
import { ShopRoutingModule } from './shop-routing.module';
import { ShopMainComponent } from './shop.component';
import { CheckCompatibilityComponent } from './check-compatibility/check-compatibility.component';
import { QuickMdnComponent } from './quick-top-up/quick-mdn/quick-mdn.component';
import { QuickSuccessComponent } from './quick-top-up/quick-success/quick-success.component';
import { QuickVoucherComponent } from './quick-top-up/quick-voucher/quick-voucher.component';
import { CheckoutResultComponent } from './checkout-result/checkout-result.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CartComponent } from './cart/cart.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CheckoutHeaderComponent } from './checkout-header/checkout-header.component';
import { CheckoutNavComponent } from './checkout-nav/checkout-nav.component';

@NgModule({
  declarations: [
    ShopMainComponent,
    CheckCompatibilityComponent,
    CheckoutResultComponent,
    QuickMdnComponent,
    QuickSuccessComponent,
    QuickVoucherComponent,
    CartComponent
  ],
  imports: [
    CommonModule,
    WidgetsModule,
    FormsModule,
    ReactiveFormsModule,
    ShopRoutingModule,
    MatAutocompleteModule,
    CheckoutHeaderComponent,
    CheckoutNavComponent,
    NgCircleProgressModule.forRoot({
      showTitle: true,
      showSubtitle: false,
      showUnits: false,
      showInnerStroke: false
    })
  ]
})
export class ShopModule { }
